import PageLayout, {PageDescription} from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

const ServerErrorPage = () => {
  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.SERVICE_ERROR}}
      showLogo
      footerProps={{type: 'simple'}}
      pageDescription={PageDescription.GUIDE}
    >
      <div className="wrap_comm wrap_error">
        <div className="cont_comm">
          <strong className="tit_info">서비스 오류 안내</strong>
          <p className="desc_info">
            예상하지 못한 오류가 발생했습니다.
            <br />
            서버의 일시적인 장애이거나 네트워크 문제일 수<br /> 있으니 잠시 후 다시 시도해 보세요.
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default ServerErrorPage;
